module.exports = __webpack_public_path__ + "static/media/wave02.1fd04043.webp";